Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertKnockoutData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M15.89 14.55l-7-14a1 1 0 00-1.78 0l-7 14a1 1 0 000 1A1 1 0 001 16h14a1 1 0 00.89-1.45zM7 6a1 1 0 012 0v3a1 1 0 01-2 0zm1 8a1 1 0 111-1 1 1 0 01-1 1z' fill='currentColor'/%3e%3c/svg%3e",
  iconAlertKnockoutWidth: 16,
  iconAlertKnockoutHeight: 16
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian-tokens/base/icon/alert-knockout.js
// module id = 220
// module chunks = 0